import { GenericObject, Locale, UserPermission, UserRole, copyFields } from '@synergy/models';

import { Contact } from './contact';

export class User {
    public id!: number;
    public email!: string;
    public fullName!: string;
    public locale!: Locale;
    public contact!: Contact;
    public roles!: UserRole[];
    public permissions!: UserPermission[];

    public static fromPlainObject(object: GenericObject): User {
        const user = new User();

        copyFields(object, user);

        if (object['contact']) {
            user.contact = Contact.fromPlainObject(object['contact']);
        }

        return user;
    }
}
